import React, { useContext } from 'react';
import { Modal, Button } from '../ui-kit';
import { IconUndo, IconDisplay, IconDashboard } from '../ui-kit/icons';
import ActivityTypeSelector from '../general/ActivityTypeSelector';
import AccessRightsContext from '../contexts/AccessRightsContext';

import SettingsForm from './widgets/ui-kit/SettingsForm';

const GroupDashboardButtons = ({ dashboard, updateDashboardFields, saveDashboard }) => (
  <SettingsForm.Field labelColWidth={0}>
    <Button
      className="me-2 mb-1"
      disabled={dashboard.default}
      onClick={() => {
        updateDashboardFields({ default: true });
        saveDashboard();
      }}
    >
      <IconDashboard /> {I18n.t('dashboards.make_default')}
    </Button>
    <Button
      className="me-2 mb-1"
      disabled={dashboard.default_for_station_monitor}
      onClick={() => {
        updateDashboardFields({ default_for_station_monitor: true });
        saveDashboard();
      }}
    >
      <IconDisplay /> {I18n.t('dashboards.make_default_for_station_monitor')}
    </Button>
    {!dashboard.default && !dashboard.default_for_station_monitor && (
      <Button
        className="me-2 mb-1"
        onClick={() => {
          updateDashboardFields({ type: 'personal', personal: true });
          saveDashboard();
        }}
      >
        <IconUndo /> {I18n.t('dashboards.make_personal')}
      </Button>
    )}
  </SettingsForm.Field>
);

const PersonalDashboardButtons = ({ dashboard, updateDashboardFields, saveDashboard, groupDashboardEditRights }) =>
  groupDashboardEditRights && (
    <SettingsForm.Field labelColWidth={0}>
      <Button
        className="me-2 mb-1"
        disabled={!dashboard.personal}
        onClick={() => {
          updateDashboardFields({ type: 'group', personal: false });
          saveDashboard();
        }}
      >
        {I18n.t('dashboards.make_group')}
      </Button>
    </SettingsForm.Field>
  );

const DashboardSettings = ({
  show,
  hide,
  updateDashboardFields,
  dashboard,
  activityTypes,
  saveDashboard,
  groupDashboardEditRights
}) => (
  <Modal size="xl" show={show} onHide={hide}>
    <Modal.Header closeButton>
      <Modal.Title>{I18n.t('settings')}</Modal.Title>
    </Modal.Header>
    <Modal.Body style={{ minHeight: '500px' /* for activity type dropdown */ }}>
      <SettingsForm updateWidgetSettingsField={updateDashboardFields} widgetSettings={dashboard}>
        {useContext(AccessRightsContext).admin && (
          <Button
            href={`/admin/dashboards/${dashboard.id}/edit?return_path=${globalThis.location.pathname}`}
            variant="danger"
            className="mb-3"
          >
            Admin settings
          </Button>
        )}
        <SettingsForm.Section>
          <SettingsForm.Section.Header>{I18n.t('display')}</SettingsForm.Section.Header>
          <SettingsForm.Section.Content>
            <SettingsForm.InputField
              type="number"
              fieldName="font_size_multiplier"
              label={I18n.t('activerecord.attributes.dashboards/dashboard.font_size_multiplier')}
            />
            {dashboard.personal ? (
              <PersonalDashboardButtons
                dashboard={dashboard}
                updateDashboardFields={updateDashboardFields}
                saveDashboard={saveDashboard}
                groupDashboardEditRights={groupDashboardEditRights}
              />
            ) : (
              <GroupDashboardButtons
                dashboard={dashboard}
                updateDashboardFields={updateDashboardFields}
                saveDashboard={saveDashboard}
              />
            )}
            <SettingsForm.ToggleField
              fieldName="always_show_toolbar_for_normal_users"
              label={I18n.t('dashboards.always_show_toolbar_for_normal_users')}
              description={I18n.t('dashboards.always_show_toolbar_for_normal_users_explanation')}
            />
          </SettingsForm.Section.Content>
        </SettingsForm.Section>
        <SettingsForm.Section>
          <SettingsForm.Section.Header>
            {I18n.t('activerecord.models.incidents/incident.other')}
          </SettingsForm.Section.Header>
          <SettingsForm.Section.Content>
            <SettingsForm.ToggleField
              fieldName="incident_mode_enabled"
              label={I18n.t('activerecord.attributes.dashboards/dashboard.incident_mode_enabled')}
            />
            <SettingsForm.Field
              labelColWidth={4}
              label={I18n.t('activerecord.attributes.dashboards/dashboard.incident_ignored_activity_types')}
            >
              <ActivityTypeSelector
                multi={true}
                appliesTo="incident"
                activityTypes={activityTypes}
                selectedActivityTypes={dashboard.incident_ignored_activity_type_ids || []}
                handleChange={events =>
                  updateDashboardFields({
                    incident_ignored_activity_type_ids: events.map(e => e.value)
                  })
                }
              />
            </SettingsForm.Field>
            <SettingsForm.InputField
              type="number"
              fieldName="show_incidents_for_minutes"
              label={I18n.t('activerecord.attributes.dashboards/dashboard.show_incidents_for_minutes')}
            />
          </SettingsForm.Section.Content>
        </SettingsForm.Section>
      </SettingsForm>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={hide}>
        {I18n.t('close')}
      </Button>
      <Button
        variant="success"
        onClick={() => {
          saveDashboard();
          hide();
        }}
      >
        {I18n.t('save')}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default DashboardSettings;
